import { FadeUp, Overline } from "@/components/Motion";
import { CHAPTERS } from "@/data/site";
import { useLang, TA, u } from "@/data/i18n";

export default function Legacy() {
  const { lang } = useLang();
  return (
    <section id="legacy" data-testid="legacy-section" className="py-24 md:py-32 bg-paper">
      <div className="max-w-[1500px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10 mb-20">
          <div className="md:col-span-5">
            <FadeUp>
              <Overline>{u(lang, "legacy_overline")}</Overline>
              <h2 className="mt-4 font-display font-black tracking-tight text-4xl md:text-5xl text-leaf leading-[1.02]">
                {u(lang, "legacy_heading")}
              </h2>
            </FadeUp>
          </div>
          <div className="md:col-span-7 flex items-end">
            <FadeUp delay={0.15}>
              <p className="text-muted text-base md:text-lg leading-relaxed max-w-2xl">
                {u(lang, "legacy_intro")}
              </p>
            </FadeUp>
          </div>
        </div>

        <div className="flex flex-col">
          {CHAPTERS.map((c, i) => (
            <FadeUp key={c.no} delay={0.05 * i}>
              <div
                data-testid={`chapter-${c.no}`}
                className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-10 border-t border-ink/10 py-12 md:py-16 transition-colors duration-500 hover:bg-white"
              >
                <div className="md:col-span-3 flex md:flex-col items-baseline md:items-start gap-4">
                  <span className="font-display font-black text-6xl md:text-8xl tracking-tighter text-stroke-leaf group-hover:text-leaf transition-all duration-500 group-hover:[-webkit-text-stroke:0px]">
                    {c.no}
                  </span>
                  <span className="text-xs tracking-[0.3em] uppercase font-bold text-leaf-bright">{c.year}</span>
                </div>
                <div className="md:col-span-4">
                  <h3 className="font-display font-bold text-2xl md:text-3xl text-leaf tracking-tight">
                    {lang === "ta" ? TA.chapters[i].title : c.title}
                  </h3>
                </div>
                <div className="md:col-span-5">
                  <p className="text-muted leading-relaxed text-base md:text-lg">
                    {lang === "ta" ? TA.chapters[i].body : c.body}
                  </p>
                </div>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
